var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "overlay__wrapper"
    },
    [
      _c("div", { staticClass: "overlay" }, [
        _c(
          "div",
          { staticClass: "overlay__header", on: { click: _vm.handleMinimize } },
          [
            _vm._t("title", function() {
              return [
                _c("span", { staticClass: "overlay__title" }, [
                  _vm._v(_vm._s(_vm.title))
                ])
              ]
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "overlay__header-button overlay__header-button--minimize",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.handleMinimize.apply(null, arguments)
                  }
                }
              },
              [_c("i", { staticClass: "el-icon-minus" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "overlay__header-button overlay__header-button--close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.handleClose.apply(null, arguments)
                  }
                }
              },
              [_c("i", { staticClass: "el-icon-close" })]
            )
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.minimized,
                expression: "!minimized"
              }
            ],
            staticClass: "overlay__body"
          },
          [_vm._t("default")],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }